import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue'

export function useRegistroPreventa() {
    const instance = getCurrentInstance()
    const store = instance.proxy.$store

    const registro = ref(null)
    const captchaToken = ref(null)
    const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1024)
    const sitekey = process.env.VUE_APP_CLOUDFLARE_SITE_KEY

    const tiposDocumento = [
        { type: "DNI", value: "" },
        { type: "NIE", value: "" },
        { type: "NIF", value: "" },
        { type: "PASAPORTE", value: "" },
        { type: "OTROS", value: "" }
    ]

    const esMovil = computed(() => windowWidth.value <= 768)
    const user = computed(() => store.getters.getUser)

    const inicializarRegistro = () => {
        registro.value = {
            name: user.value.name,
            surnames: user.value.surnames,
            tipoDocumentoSeleccionado: tiposDocumento.find(tipo => tipo.type === 'DNI'),
            nif: user.value.nif,
            telefono: user.value.telefono,
            location_id: user.value.location_id,
            localidad: user.value.localidad,
            province_id: user.value.province_id,
            provincia: user.value.provincia
        }
    }

    const onCaptchaSuccess = token => {
        captchaToken.value = token
    }

    const updateWindowWidth = () => {
        if (typeof window !== 'undefined') {
            windowWidth.value = window.innerWidth
        }
    }

    onMounted(() => {
        inicializarRegistro()
        if (typeof window !== 'undefined') {
            windowWidth.value = window.innerWidth
            window.addEventListener('resize', updateWindowWidth)
        }
    })

    onUnmounted(() => {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', updateWindowWidth)
        }
    })

    return {
        registro,
        captchaToken,
        sitekey,
        esMovil,
        onCaptchaSuccess
    }
}
